// extracted by mini-css-extract-plugin
export default {"templatesHeader":"templates-table_templatesHeader__bOFzj","templatesTable":"templates-table_templatesTable__ztG47"};